'use client';

import { c as _c } from "react/compiler-runtime";
import { useFeatureFlags } from '@/lib/shared/components/FeatureFlagsProvider';

// Bottom-right floating help launcher. Visually replicates the Intercom
// chat-bubble launcher we shipped for over a year so users keep the same
// affordance, but the SVG is inlined (no third-party fetch) and the click
// just opens help.morpho.org in a new tab. The Intercom JS SDK was removed
// because vendor-rotated scripts can't be SRI-pinned and ran in the same
// origin as window.ethereum — see APPS-798.
//
// The `intercom` LD flag is kept as a kill-switch (was the SDK init gate;
// now it gates this redirect launcher).
const HelpLauncher = () => {
  const $ = _c(2);
  const {
    intercom: isEnabled
  } = useFeatureFlags();
  if (!isEnabled) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      backgroundColor: "#2973FF",
      bottom: 30,
      right: 30,
      boxShadow: "rgba(0, 0, 0, 0.06) 0px 1px 6px 0px, rgba(0, 0, 0, 0.16) 0px 2px 32px 0px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <a href="https://help.morpho.org" target="_blank" rel="noopener noreferrer" aria-label="Help" className="fixed z-50 flex h-12 w-12 items-center justify-center rounded-full transition hover:scale-105" style={t0}><svg focusable="false" aria-hidden="true" viewBox="0 0 28 32" width="24" height="24" fill="#fff"><path d="M28,32 C28,32 23.2863266,30.1450667 19.4727818,28.6592 L3.43749107,28.6592 C1.53921989,28.6592 0,27.0272 0,25.0144 L0,3.6448 C0,1.632 1.53921989,0 3.43749107,0 L24.5615088,0 C26.45978,0 27.9989999,1.632 27.9989999,3.6448 L27.9989999,22.0490667 L28,22.0490667 L28,32 Z M23.8614088,20.0181333 C23.5309223,19.6105242 22.9540812,19.5633836 22.5692242,19.9125333 C22.5392199,19.9392 19.5537934,22.5941333 13.9989999,22.5941333 C8.51321617,22.5941333 5.48178311,19.9584 5.4277754,19.9104 C5.04295119,19.5629428 4.46760991,19.6105095 4.13759108,20.0170667 C3.97913051,20.2124916 3.9004494,20.4673395 3.91904357,20.7249415 C3.93763774,20.9825435 4.05196575,21.2215447 4.23660523,21.3888 C4.37862552,21.5168 7.77411059,24.5386667 13.9989999,24.5386667 C20.2248893,24.5386667 23.6203743,21.5168 23.7623946,21.3888 C23.9467342,21.2215726 24.0608642,20.9827905 24.0794539,20.7254507 C24.0980436,20.4681109 24.0195551,20.2135019 23.8614088,20.0181333 Z" /></svg></a>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default HelpLauncher;